import React from "react";
import UserNav from "../components/navbar/UserNav";
// import SimulatorNav from "../components/simulator-nav/SimulatorNav";
import { useSelector } from "react-redux";
import { networkTypeSelector } from "store/userSliceHelpers";
import "../index.css";
import "./user-layout.css";

interface Props {
  children: React.ReactNode;
}

function UserLayout({ children }: Props) {
  const networkType = useSelector(networkTypeSelector);

  return (
    <div className="gp-v1-layout">
      <div className="gp-v1-layout-inner">
        <UserNav networkType={networkType} />
        <section className="gp-v1-layout-content">{children}</section>
      </div>
      <div className="gp-v1-footer">© 2026 gardioPay · Kea Valley</div>
      {/* <SimulatorNav /> */}
    </div>
  );
}

export default UserLayout;
